module.exports = __webpack_public_path__ + "static/slide1-8f199bbe3a1c1a022d349c94f4ee255f.jpg";